module.exports = __webpack_public_path__ + "img/tel.8f490a97.png";